// extracted by mini-css-extract-plugin
export default {"Form":"SignInForm_Form__cbaYD","FormElements":"SignInForm_FormElements__TL7en"};